<template>
  <v-row justify="center">
    <v-btn
      class="btn-report-activity btn-color"
      fab
      small
      color="green"
      @click="manage()"
    >
    <v-icon dark> mdi-domain </v-icon>
    </v-btn>
    <v-dialog
      scrollable
      v-model="dialog"
      fullscreen
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-toolbar dark color="primary"  style="justify-content: flex-end;display: flex;">
          <v-toolbar-items>
            <v-btn dark text @click="dialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-list three-line subheader>
          <div class="container">
            <v-col cols="auto">
              <v-card style="background-color: white; margin: auto;" elevation="1" class="mb-6 mt-4">
                <v-row>
                  <v-col cols="12" md="4">
                    <v-row>
                      <v-col class="picture" cols="12" md="6" align="right">
                        <v-avatar size="150">
                          <img alt="user" :src="formUpdate.pictureUrl" />
                        </v-avatar>
                      </v-col>
                      <v-col class="text" cols="12" md="6">
                        <h3 class="mb-0">กิจกรรม</h3>
                        <v-row no-gutters>
                          <v-col cols="12">
                            <v-icon color="blue darken-2">
                              mdi-checkbox-marked-circle
                            </v-icon>
                            {{ titleActivity }}
                          </v-col>
                          <v-col cols="12">
                            <p1>
                              <v-icon  color="blue darken-2">
                                mdi-account</v-icon
                              >
                              quota: {{ formUpdate.quota }}
                            </p1>
                          </v-col>
                          <v-col cols="12">
                            <p1>
                              <v-icon color="blue darken-2">
                                mdi-poll
                              </v-icon>
                              ประเภทกิจกรรม: {{ formUpdate.type }}
                            </p1>
                          </v-col>
                          <v-col cols="12">
                            <p1>
                              <v-icon color="blue darken-2">
                                mdi-account-cog-outline
                              </v-icon>
                              จำนวนที่เข้าร่วมได้: {{ formUpdate.repeats }}
                            </p1>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col class="textdetail" cols="12" md="2" align="left">
                    <v-row>

                      <v-col class="text" align="left">
                        <h3 style="text-align: left;" class="mb-0 padding-0">
                          ระยะเวลา กิจกรรม
                        </h3>
                        <v-row no-gutters>
                          <v-col cols="12">
                            <p1 style="text-align: center;">
                              <v-icon  color="blue darken-2">
                                mdi-calendar</v-icon
                              >
                              {{ "วันที่เริ่มกิจกรรม: " + formUpdate.startDate }}
                            </p1>
                          </v-col>
                          <v-col cols="12">
                            <p1 style="text-align: center;">
                              <v-icon  color="blue darken-2">
                                mdi-calendar
                              </v-icon>
                              {{ "วันที่จบกิจกรรม: " + formUpdate.endDate }}
                            </p1>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="5">
                    <v-row justify="center">
                      <v-col>
                          <v-card style="background-color: #1b437c; height: 6rem;display: flex;flex-direction: column;align-items: center;justify-content: center;">
                              <h5 style="color: white;  margin-bottom: 0;">
                                All Member
                              </h5>
                              <h1 style="text-align: center; color: white;">
                                {{ formUpdate.TotalMember }}
                              </h1>
                          </v-card>
                      </v-col>
                      <v-col>
                          <v-card style="background-color: #1b437c; height: 6rem;display: flex;flex-direction: column;align-items: center;justify-content: center;">
                              <h5 style="color: white;  margin-bottom: 0;">
                                Join Member
                              </h5>
                              <h1 style="text-align: center; color: white;  margin: 0;">
                                 {{ formUpdate.countMember }}
                              </h1>
                                <p v-if="status === 'up'" class="chart-text-up font-weight-bold mb-0" style="text-align: center;color: white;"><v-icon class="chart-text-up" color="green">mdi-arrow-up-bold</v-icon> {{change}} %</p>
                                <p v-else-if="status === 'down'" class="chart-text-down font-weight-bold mb-0" style="text-align: center;color: white;"><v-icon class="chart-text-down" color="green">mdi-arrow-down-bold</v-icon> {{change}} %</p>
                                <p v-else class="chart-text-up font-weight-bold mb-0" style="text-align: center;color: white;"><v-icon class="chart-text-up" color="green">mdi-arrow-up-bold</v-icon> {{change}} %</p>
                          </v-card>
                          <p style="text-align: center;color: green;margin-top: 10px;" v-if="status === 'up'">เพิ่มขึ้นจากเเดือนที่ผ่านมา</p>
                      </v-col>
                      <v-col>
                          <v-card style="background-color: #1b437c; height: 6rem;display: flex;flex-direction: column;align-items: center;justify-content: center;">
                              <h5 style="color: white;  margin-bottom: 0;">
                                Percenttage
                              </h5>
                              <h1 style="text-align: center; color: white;">
                                {{ Number.parseFloat(formUpdate.Percentage).toFixed(2) + '%' }}
                              </h1>
                          </v-card>
                      </v-col>
                  </v-row>
                  </v-col>
                </v-row>
              </v-card>
              <v-row>
                <v-col cols="12" md="5">
                  <v-row>
                    <v-col align="center" style="display: flex;align-items: center;">
                      <h3 class="font-table">โควต้าที่ถูกใช้ สาขา/บริการ</h3>
                    </v-col>
                    <v-col align="center" style="display: flex;align-items: center;justify-content: end;">
                      <v-btn color="indigo" style="margin-bottom: 10px;" outlined>
                        <v-icon left color="indigo">mdi-download</v-icon>
                        <download-excel
                          class="btn btn-default indigo--text"
                          :data="export_data2"
                          :fields="export_fields2"
                          :type="exportType"
                          :worksheet="exportWorksheet"
                          :name="exportFileName"
                        >
                          Export
                        </download-excel>
                      </v-btn>
                    </v-col>
                  </v-row>
                  <v-card elevation="1" v-if="dataReady">
                    <v-card-title>
                      <v-text-field
                        v-model="searchAll3"
                        append-icon="mdi-magnify"
                        label="Search"
                        single-line
                        hide-details
                        dense
                      ></v-text-field>
                    </v-card-title>
                    <v-card-text>
                      <v-data-table
                        :headers="columns"
                        :items="form"
                        :search="searchAll3"
                        :items-per-page="3"
                        dense
                        style="min-height:255px"
                      >
                      </v-data-table>
                    </v-card-text>
                  </v-card>
                  <div v-if="!dataReady" class="text-center">
                    <v-progress-circular
                      indeterminate
                      color="primary"
                    ></v-progress-circular>
                  </div>
                </v-col>
                <v-col cols="12" md="7">
                  <div class="card-dougnut">
                    <ChartDoughnutService
                     ref="ax"
                      :activityId="activityId"
                    />
                  </div>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="5">
                  <v-row>
                    <v-col align="center" style="display: flex;align-items: center;">
                      <h2 class="font-table">บรอดแคส</h2>
                    </v-col>
                    <v-col align="center" style="display: flex;align-items: center;justify-content: end;">
                      <v-btn color="indigo" style="margin-bottom: 10px;" outlined>
                        <v-icon left color="indigo">mdi-download</v-icon>
                        <download-excel
                          class="btn btn-default indigo--text"
                          :data="export_data"
                          :fields="export_fields"
                          :type="exportType"
                          :worksheet="exportWorksheet"
                          :name="exportFileNameBroadCast"
                        >
                          Export
                        </download-excel>
                      </v-btn>
                    </v-col>
                  </v-row>
                  <v-card elevation="1" v-if="dataReady">
                    <v-card-title>
                      <v-text-field
                        v-model="searchAll2"
                        append-icon="mdi-magnify"
                        label="Search"
                        single-line
                        hide-details
                        dense
                      ></v-text-field>
                    </v-card-title>
                    <v-card-text>
                      <v-data-table
                        :headers="columns2"
                        :items="formBroadcast"
                        :search="searchAll2"
                        :items-per-page="3"
                        dense
                        style="min-height:260px"
                      >
                        <template v-slot:[`item.pictureUrl`]="{ item }">
                          <v-avatar color="primary" size="40">
                            <img :src="item.pictureUrl" alt="img"
                          /></v-avatar>
                        </template>
                        <template v-slot:[`item.LAST_DATE`]="{ item }">
                          {{ thaiFormattedDate(item.LAST_DATE) }}
                        </template>
                      </v-data-table>
                    </v-card-text>
                  </v-card>
                  <div v-if="!dataReady" class="text-center">
                    <v-progress-circular
                      indeterminate
                      color="primary"
                    ></v-progress-circular>
                  </div>
                </v-col>
                <v-col cols="12" md="7">
                  <v-card elevation="1" style="background-color: #1b437c">
                    <v-container>
                      <v-row>
                        <v-spacer></v-spacer>
                        <v-col cols="12" md="3">
                          <v-menu
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="auto"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                v-model="picker"
                                prepend-icon="mdi-calendar"
                                color="blue darken-2"
                                readonly
                                v-bind="attrs"
                                v-on="on"
                                dark
                                width="400"
                              ></v-text-field>
                            </template>
                            <v-date-picker
                              v-model="picker"
                              type="month"
                              this.picker="picker"
                              @change="selectDate(picker)"
                            ></v-date-picker>
                          </v-menu>
                        </v-col>
                        <v-spacer></v-spacer>
                      </v-row>
                      <v-card img-bottom>
                        <ChartLineBase
                          width="1248"
                          height="670"
                          :chartData="this.chartData"
                          ref="test"
                        />
                      </v-card>
                    </v-container>
                  </v-card>
                </v-col>
              </v-row>
            </v-col>
          </div>
        </v-list>
      </v-card>
    </v-dialog>
    <!-- เพิ่มเติม -->
  </v-row>
</template>
<script>
// import { defineComponent } from '@vue/composition-api'
import axios from 'axios' // api
import moment from 'moment'
import ChartDoughnutService from './ChartMemberUseActivity.vue'
import ChartLineBase from './ChartLineAllActivityMemberjoinBase'
import JsonExcel from 'vue-json-excel' // https://www.npmjs.com/package/vue-json-excel
import XLSX from 'xlsx' // import xlsx
export default {
  components: {
    ChartDoughnutService,
    ChartLineBase,
    downloadExcel: JsonExcel,
    XLSX
    // QrcodeStream
    // readXlsxFile
  },
  props: ['activityId', 'titleActivity', 'shopId'],
  data () {
    return {
      picker: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10)
        .slice(0, 7),
      Month: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10)
        .slice(0, 7),
      title: 'Loyalty',
      path: '/activity/',
      chartData2: null,
      dialog: false,
      searchAll2: '',
      searchAll3: '',
      form: [],
      picture: [],
      formLineChart: [],
      formBroadcast: [],
      export_data2: [],
      prev: [],
      change: '',
      status: '',
      columns: [
        // { text: 'activity', value: 'activity' },
        { text: 'บริการ', value: 'service' },
        { text: 'สาขา', value: 'branchName' },
        { text: 'จำนวนผู้เข้าใช้(ครั้ง)', value: 'MEmberJoinB', align: 'center' }
      ],
      columns2: [
        { text: 'Profile', value: 'pictureUrl' },
        { text: 'Audiences Name', value: 'audiencesName' },
        { text: 'กิจกรรม', value: 'message', align: 'center' },
        { text: 'จำนวนผู้เข้าใช้', value: 'countUser', align: 'center' },
        { text: 'วันที่', value: 'LAST_DATE', align: 'center' }
      ],
      formUpdate: '',
      chartData: null,
      data: {
        week: Array(31).fill(0)
      },
      labels: {
        week: []
      },
      exportType: 'xls',
      exportFileName: 'Report_Activity_Branch_Summary',
      exportFileNameBroadCast: 'Report_Activity_BroadCast_Summary',
      exportWorksheet: 'WorkSheet',
      export_fields: {
        audiences_name: 'audiencesName',
        total_member: 'countUser',
        activity: 'message',
        activityID: 'referId',
        date: 'LAST_DATE'
      },
      export_fields2: {
        activity: 'activity_name',
        branchName: 'branchName',
        service: 'service',
        Member_name: 'Member_name',
        Level: 'name',
        totalPoint: 'totalPoint',
        collectPoint: 'collectPoint',
        redeemPoint: 'redeemPoint'
      }
    }
  },
  beforeCreate () {
    if (!this.$session.exists()) {
      this.$router.push('/Core/Login')
    }
  },
  async mounted () {
    await this.selectDate(this.picker)
    await this.gettable()
    this.generateFileName()
  },
  methods: {
    generateFileName () {
      const date = moment().format('DDMMYYYY')
      this.exportFileName = `Report_Activity_Branch_Summary_${date}.xls`
      this.exportFileNameBroadCast = `Report_Activity_BroadCast_Summary_${date}.xls`
    },
    async gettable () {
      await axios
        .get(
          this.DNS_IP + '/last-member-use-activity/' +
            'get?activityId=' +
            this.activityId + '&shopId=' + this.$session.getAll().data.shopId
        )
        .then(async (response) => {
          this.form = response.data
          if (this.form.length === 0 || this.form.status === false) {
            this.form = []
          } else {
            this.form.map((item, i) => {
              item.service === null ? item.service = 'ไม่มีข้อมูล' : item.service = item.service
              item.branchName === null ? item.branchName = 'ไม่มีข้อมูล' : item.branchName = item.branchName
            })
          }
          console.log('form1', this.form)
        })
        .catch((error) => {
          console.log(error)
          this.dataReady = true
        })
      await axios
        .get(
          this.DNS_IP + '/activity/get?shopId=' +
            this.shopId
        )
        .then(async (response) => {
          this.formUpdate = response.data.filter(item => item.activityId === this.activityId)[0]
          if (this.formUpdate.countUse === 0) {
            this.formUpdate.countMember = this.formUpdate.countUse
          }
          if (this.formUpdate.repeats !== 'OneTime') {
            this.formUpdate.Percentage = this.formUpdate.countMember * 100 / this.formUpdate.TotalMember
          } else if (this.formUpdate.repeats === 'OneTime') {
            this.formUpdate.Percentage = this.formUpdate.countUse * 100 / this.formUpdate.TotalMember
          }
          console.log('form222221', this.formUpdate)
        })
        .catch((error) => {
          console.log(error)
          this.dataReady = true
        })
      await axios
        .get(
          this.DNS_IP + '/broadcast/getGroup?referId=' + this.activityId
        )
        .then(async (response) => {
          this.formBroadcast = response.data
          this.export_data = response.data
          if (
            this.formBroadcast.length === 0 ||
            this.formBroadcast.status === false
          ) {
            this.formBroadcast = []
          }
          console.log('databroadcast', this.formBroadcast)
        })
        .catch((error) => {
          console.log(error)
          this.dataReady = true
        })
      await axios
        .get(
          this.DNS_IP + '/get-data-branch-service/get?activityId=' +
            this.activityId
        )
        .then(async (response) => {
          console.log('this.export_data2', response.data)
          this.export_data2 = response.data
        })
        .catch((error) => {
          console.log(error)
          this.dataReady = true
        })
      await axios
        .get(
          this.DNS_IP + '/get-current-prev/get?activityId=' +
            this.activityId + '&currentDate=' + this.Month
        )
        .then(async (response) => {
          if (response.data.length > 0) {
            this.prev = response.data[0]
            console.log('test', this.prev)
            this.status = (this.prev.currentMonth > this.prev.prevMonth) ? 'up' : 'down'
            if (this.prev.currentMonth > this.prev.prevMonth) {
              if (this.prev.prevMonth === 0) {
                this.change = this.prev.currentMonth * 100
              } else {
                const a = this.prev.currentMonth - this.prev.prevMonth
                this.change = (a / this.prev.prevMonth * 100).toFixed(2)
              }
            } else if (this.prev.prevMonth > this.prev.currentMonth) {
              const b = this.prev.prevMonth - this.prev.currentMonth
              this.change = (b / this.prev.prevMonth * 100).toFixed(2)
            }
          }
        })
        .catch((error) => {
          console.log(error)
          if (this.prev === undefined) {
            this.change = 0
          }
          this.dataReady = true
        })
    },
    selectDate2 () {
      console.log('dddd')
    },
    async selectDate (Date) {
      this.data.week = Array(31).fill(0)
      console.log(Date)
      this.labels.week = []
      const year = Date.split('-')[0]
      const month = Date.split('-')[1]
      let day = this.daysInMonth(month, year)
      for (var i = 0; i < day; i++) {
        var data = {}
        data.date = (i + 101).toString().substr(1, 2) + '/' + month + '/' + year
        data.dateLabels = (i + 101).toString().substr(1, 2)
        this.labels.week.push(data.dateLabels)
      }
      await axios
        .get(
          this.DNS_IP + '/get-date-member-join-activity/get?activityId=' +
            this.activityId +
            '&date=' +
            Date
        )
        .then(async (response) => {
          let rs = response.data
          console.log(response.data)
          if (response.data.status === false) {
            this.data.week = Array(31).fill(0)
            this.fillData()
          } else {
            console.log(rs)
            for (let i = 0; i < rs.length; i++) {
              var d = rs[i]
              this.data.week[parseInt(d.joinDate.slice(8, 10)) - 1] = d.Member
              console.log(rs.member)
            }
            this.fillData()
          }
        })
        .catch((error) => {
          console.log(error)
          // this.fillData()
        })
    },
    fillData () {
      this.chartData = {
        labels: this.labels.week,
        datasets: [
          {
            borderColor: '#C9CCD5',
            data: this.data.week,
            tension: 0.4,
            label: 'Member',
            backgroundColor: '#CDF0EA'
          }
        ]
      }
    },
    daysInMonth (month, year) {
      return new Date(year, month, 0).getDate()
    },
    manage () {
      this.dialog = true
      // this.$refs.test.daysInMonth()
    }
  }
}
</script>
<style lang="css" scoped>
.export-btn {
  margin-bottom: 10px;
}
.btn-report-activity {
  outline: none;
}
.card-dougnut {
  /* margin-top: 30px; */
  justify-content: space-around;
}
.b {
  background-color: red;
}
h3 {
  font-weight: bold;
}
h5 {
  font-weight: bold;
  text-align: center;
}
.container {
  max-width: 95%;
}
.text {
  text-align: left;
}
p1 {
  margin: 0;
}
.font-table {
  margin: 0;
  color: black;
  font-size: 20px;
  position: relative;
  top: -7px;
}
@media only screen and (max-width: 767px) {
  .text {
    text-align: center;
  }
  .picture {
    display: flex;
    justify-content: center;
  }
  p {
    text-align: center;
    margin: 0;
  }
  .textdetail {
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ReportActivity/ReportActivityBS.vue